module.exports = __webpack_public_path__ + "static/img/htsj_1@2x.edf17dc9.png";